import React from "react";
import { Form } from "antd";
import { Select } from "./BaseSelect";

const LogisticsInfoStatusField: React.FC = () => {
    return (
        <Form.Item name="logisticsInfoStatus" label={<span className="search-field-label">物流信息</span>}>
            <Select
                options={[
                    {
                        value: "",
                        label: "",
                    },
                    {
                        value: "noLogisticsInfo",
                        label: "无物流信息",
                    },
                    {
                        value: "hasLogisticsInfo",
                        label: "有物流信息",
                    },
                ]}
            />
        </Form.Item>
    );
};

export default React.memo(LogisticsInfoStatusField);
